import { toast } from 'react-toastify';
import {
  ENTITLEMENTS_SUCCESS,
  ENTITLEMENTS_CREATE,
} from '../constants/actions';

export function loadEntitlements(user) {
  return (dispatch) => {
    // Call the club api to find the users.
    window.usersApi.get(`/v1/admin/users/${user.uuid}/entitlements?domain=com.familienort.my`)
      .then((response) => {
        dispatch({ type: ENTITLEMENTS_SUCCESS, data: response.data });
      })
      .catch((response) => {
        // TODO
      });
  };
}

export function resetPlan(user_id, data) {
  return (dispatch) => {
    // Call the club api to find the users.
    window.usersApi.put(`/v1/admin/users/${user_id}/plan`, data)
      .then((response) => {
        if (response.status < 300) {
          toast.success("Successfully reset users entitlements");
          dispatch({ type: ENTITLEMENTS_CREATE, data: response.data });
        } else {
          throw new Error("Wrong status code");
        }
      })
      .catch((response) => {
        toast.error("Failed reset users entitlements");
      });
  };
}
